export default "__VITE_ASSET__BRzd3YwY__"